"use strict";

import Vue from 'vue'
import axios from "axios"
import router from '@/router'
import store from '@/store'
//import Qs from 'qs'
import {Message} from 'view-design'

let config = {
	baseURL: API_URL,
	headers: {
		'Content-Type': 'application/json'
	},
	// transformRequest: [function(data) {
	// 	data = Qs.stringify(data)
	// 	return data
	// }],
	timeout: 15 * 1000
};

const _axios = axios.create(config);


_axios.interceptors.request.use(
	function(config) {
		config.headers.['Accept-Language'] = localStorage.localeLanguage
		if (store.state.token) {
			config.headers.Authorization = 'Bearer ' + store.state.token
		}
		return config;
	},
	function(error) {
		return Promise.reject(error);
	}
);

_axios.interceptors.response.use(
	function(response) {
		// console.log(response)
		return response;
	},
	function(error) {
		// console.log(error)
		if (error.code == 'ECONNABORTED') {
			// Message.error(111)
		}
		if (error.response) {
			switch (error.response.status) {
				case 401:
					router.replace({
						path: '/login'
					})
					break
				case 403:
					router.replace({
						path: '/login'
					})
					break
				default:
					// Message.error(111)
					break
			}
		} else {
			// Message.error(111)
		}
		return Promise.reject(error);
	}
);

Plugin.install = function(Vue, options) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		},
	});
};

Vue.use(Plugin)

export default Plugin;
